import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "select-content-title"
};
const _hoisted_2 = {
  class: "display-name"
};
const _hoisted_3 = {
  class: "display-name-select"
};
const _hoisted_4 = {
  key: 0,
  class: "please-select"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 0,
  class: "size-items"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0,
  class: "asin-select"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "img-back"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "asin-value"
};
const _hoisted_15 = {
  class: "asin-select asin-select-swipe"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "img-back"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = ["onClick", "src"];
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import { handleChunkArr, TWISTER_DIMENSION } from './BuyingOptionsPopup';
import imageLink from '@/configs/imageLink';
import { get } from 'lodash-es';
const MAX_SHOW_BIG_PICTURE = 19;
const NUMBERS_OF_SLIDE_IMAGES = 6;

// View large image controller

export default {
  __name: 'BuyAsinList',
  props: {
    twisterValue: {
      type: Object,
      default: () => {}
    },
    selectedTwister: {
      type: Object,
      default: () => {}
    },
    twisterColorImage: {
      type: Object,
      default: () => {}
    },
    asinDetails: {
      type: Object
    },
    twisterStatus: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['onClickTwister', 'seeLargeImg'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t,
      te
    } = useI18n();
    const {
      TWISTER_DIMESIN_KEYS,
      IMAGE_URL
    } = constants;
    const {
      NO_DATA_IMAGE
    } = imageLink;
    const TWISTER_LIST_SVG = `${IMAGE_URL}assets/svg/twisterList.png`;
    const router = useRouter();
    const CATEGORY_NAME = {
      SHOSE: 'gl_shoes',
      APPAREL: 'gl_apparel'
    };
    const isSeePictureBig = ref(false);
    const onTypeSelect = () => {
      isSeePictureBig.value = !isSeePictureBig.value;
    };
    const onClickTwister = (index, item) => {
      emit('onClickTwister', index, item);
    };
    const seeLargeImg = url => {
      emit('seeLargeImg', url);
    };
    const onClothesSize = () => {
      router.push({
        name: 'sizeChart'
      });
    };
    const stopWatchAsin = watch(() => {
      var _props$asinDetails;
      return (_props$asinDetails = props.asinDetails) === null || _props$asinDetails === void 0 ? void 0 : _props$asinDetails.asin;
    }, val => {
      if (val) {
        var _props$twisterValue;
        const colorItem = (_props$twisterValue = props.twisterValue) === null || _props$twisterValue === void 0 ? void 0 : _props$twisterValue[TWISTER_DIMESIN_KEYS.COLOR_NAME];
        isSeePictureBig.value = colorItem ? (colorItem === null || colorItem === void 0 ? void 0 : colorItem.length) < MAX_SHOW_BIG_PICTURE : false;
        stopWatchAsin();
      }
    });
    function isTwisterSelectable(twisterName, value) {
      return get(props.twisterStatus, [twisterName, value, 'selectable'], false) && !get(props.twisterStatus, [twisterName, value, 'insufficient'], false);
    }
    return (_ctx, _cache) => {
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.twisterValue, (values, name) => {
        var _props$selectedTwist;
        return _openBlock(), _createElementBlock("div", {
          class: "select-content-item",
          key: name
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(te)(`modules.checkout.${_unref(TWISTER_DIMENSION)[name]}`) ? _unref(t)(`modules.checkout.${_unref(TWISTER_DIMENSION)[name]}`) : name), 1), !((_props$selectedTwist = __props.selectedTwister) !== null && _props$selectedTwist !== void 0 && _props$selectedTwist[name]) ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('modules.checkout.PLEASE_SELECT')), 1)) : _createCommentVNode("", true)]), name === _unref(TWISTER_DIMESIN_KEYS).SIZE_NAME && (__props.asinDetails.glProductGroup === CATEGORY_NAME.SHOSE || __props.asinDetails.glProductGroup === CATEGORY_NAME.APPAREL) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", {
          onClick: onClothesSize
        }, _toDisplayString(_unref(t)('modules.checkout.SIZE_CHART')), 1)])) : name === _unref(TWISTER_DIMESIN_KEYS).COLOR_NAME ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: onTypeSelect
        }, [_createElementVNode("img", {
          class: "twister-list",
          src: TWISTER_LIST_SVG,
          alt: ""
        }), !isSeePictureBig.value ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('modules.checkout.LARGE_IMAGE')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('modules.checkout.DIFFERENT_ASIN_TYPES_LIST')), 1))])) : _createCommentVNode("", true)]), name !== _unref(TWISTER_DIMESIN_KEYS).COLOR_NAME ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values, value => {
          var _props$selectedTwist2;
          return _openBlock(), _createElementBlock("li", {
            key: 'spec-name-' + value,
            onClick: $event => onClickTwister(name, value),
            class: _normalizeClass({
              selected: ((_props$selectedTwist2 = __props.selectedTwister) === null || _props$selectedTwist2 === void 0 ? void 0 : _props$selectedTwist2[name]) === value,
              disabled: !isTwisterSelectable(name, value)
            })
          }, [_createElementVNode("span", null, _toDisplayString(value), 1)], 10, _hoisted_9);
        }), 128))])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [!isSeePictureBig.value ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values, value => {
          var _props$selectedTwist3;
          return _openBlock(), _createElementBlock("li", {
            key: 'spec-name-' + value,
            onClick: $event => onClickTwister(name, value),
            class: _normalizeClass({
              'min-picture': true,
              selected: ((_props$selectedTwist3 = __props.selectedTwister) === null || _props$selectedTwist3 === void 0 ? void 0 : _props$selectedTwist3[name]) === value,
              disabled: !isTwisterSelectable(name, value)
            })
          }, [_createElementVNode("div", _hoisted_12, [(_openBlock(), _createElementBlock("img", {
            key: __props.twisterColorImage[_ctx.item],
            src: __props.twisterColorImage[value] ? __props.twisterColorImage[value] : _unref(NO_DATA_IMAGE),
            alt: ""
          }, null, 8, _hoisted_13))]), _createElementVNode("span", _hoisted_14, _toDisplayString(value), 1)], 10, _hoisted_11);
        }), 128))])) : (_openBlock(), _createBlock(_component_van_swipe, {
          key: 1,
          "indicator-color": "#565959"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(handleChunkArr)(values, NUMBERS_OF_SLIDE_IMAGES), value => {
            return _openBlock(), _createBlock(_component_van_swipe_item, {
              key: 'spec-name-' + value
            }, {
              default: _withCtx(() => [_createElementVNode("ul", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, item => {
                var _props$selectedTwist4, _props$twisterColorI;
                return _openBlock(), _createElementBlock("li", {
                  key: item,
                  onClick: $event => onClickTwister(name, item),
                  class: _normalizeClass({
                    'big-picture': true,
                    selected: ((_props$selectedTwist4 = __props.selectedTwister) === null || _props$selectedTwist4 === void 0 ? void 0 : _props$selectedTwist4[name]) === item,
                    disabled: !isTwisterSelectable(name, item)
                  })
                }, [_createElementVNode("div", _hoisted_17, [(_openBlock(), _createElementBlock("img", {
                  key: __props.twisterColorImage[item],
                  src: __props.twisterColorImage[item] ? __props.twisterColorImage[item] : _unref(NO_DATA_IMAGE),
                  alt: ""
                }, null, 8, _hoisted_18))]), (_props$twisterColorI = __props.twisterColorImage) !== null && _props$twisterColorI !== void 0 && _props$twisterColorI[item] ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "see-large-img",
                  onClick: $event => seeLargeImg(__props.twisterColorImage[item] ? __props.twisterColorImage[item] : __props.asinDetails.mainImage),
                  src: `${_unref(IMAGE_URL)}assets/image/icons/seeLargeImg.png`,
                  alt: ""
                }, null, 8, _hoisted_19)) : _createCommentVNode("", true), _createElementVNode("span", null, [_createElementVNode("span", null, _toDisplayString(item), 1)])], 10, _hoisted_16);
              }), 128))])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 2
        }, 1024))], 64))]);
      }), 128);
    };
  }
};